export const hasLetters = (value) => {
  return /[a-zA-Z]/.test(value);
}

export const isTenDigitNumber = (value) => {
  return /^\d{10}$/.test(value);
}

export const isValidEmail = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return value && emailRegex.test(value);
};

export const validatePhone = (value) => {
  if(isTenDigitNumber(value) && !hasLetters(value)) {
    return {success: true, message: ''};
  }

  return {success: false, message: 'El teléfono debe tener 10 dígitos y no debe contener letras'}
}